// src/pages/AboutTeamPage.js (or wherever it resides)
import React from 'react'; // Removed useState as it's handled in NewsletterSignup

// Import your new components
import AboutHeader from './Components/AboutHeader'; // Adjust paths as needed
import CompanyMission from './Components/CompanyMission';
import ContentCard from './Components/ContentCard';
import TeamSection from './Components/teamMembers';
import AnimatedMetricsSection from './Components/AnimatedMetrics';
import NewsletterSignup from '../newsletter/newsletter';
import AnimateOnScroll from './Components/AnimateOnScroll';

// Placeholder images (replace with actual imports if possible)
const labImage = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Fabout-us%2FlabImage.png?alt=media&token=3ac0dbd1-a0ad-45cb-9163-4fefdf590551";
const wasteImage = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Fabout-us%2FmapImage.png?alt=media&token=1ec213e2-c6fc-44e0-a8de-5355fa52e33f";

const AboutTeamPage = () => {
  return (
    <div style={{
      fontFamily: 'Helvetica, sans-serif',
      color: '#333',
      backgroundColor: '#fff', // Ensure background is white
      overflowX: 'hidden' // Prevent horizontal scrollbars from animations
    }}>

      <AboutHeader />

      <CompanyMission />

      {/* Wrap existing AnimatedMetricsSection for fade/slide effect */}
      <AnimateOnScroll threshold={0.1}> {/* Adjust threshold if needed */}
        <AnimatedMetricsSection />
      </AnimateOnScroll>

      {/* Main Content Area */}
      <div style={{
        maxWidth: '1200px',
        margin: '60px auto 0 auto', // Add margin top after metrics
        padding: '0 20px',
      }}>

        <ContentCard
          title="PLASTIC SPECTRAL LIBRARY"
          italicText="Analytical research is paramount for the compositional categorisation of plastics and microplastics in environmental samples"
          paragraphText="To determine the environmental prevalence of plastics and understand what that means for human health, compositional analysis of said entities is necessary. Spectral analysis of identified particulates typically involves the usage of Spectroscopy (Fourier Transform Infrared and Raman) and Spectrometry methods (Pyrolysis-gas chromatography-Mass spectroscopy). Why not login and use our open-source online spectral library"
          imageUrl={labImage}
          imageAlt="Laboratory analysis"
          linkHref="/spectral-library"
          linkText="here."
          imagePosition="left" // Default, but explicit
        />

        <ContentCard
          title="ENVIRONMENTAL PREVALENCE OF AIRBORNE MICROPLASTICS"
          italicText="Airborne micro- and nano- plastic pollution is a global phenomena, requiring global perspectives"
          paragraphText="With seminal publications being released in 2015, airborne microplastics are an emerging airborne particulate being found at varying concentrations globally. To assist researchers in their understanding of this emerging pollutant's global distribution, PlasticAnalytics have created an interactive map for you to explore the field's reported findings."
          imageUrl={wasteImage}
          imageAlt="Plastic waste examples"
          linkHref="/sign-in"
          linkText="Click here to explore."
          imagePosition="right" // Image on the right
        />

        <TeamSection />

      </div> {/* End Main Content Area */}

      {/* Wrap NewsletterSignup for animation */}
      <AnimateOnScroll threshold={0.5}> {/* Trigger later if desired */}
         <NewsletterSignup />
      </AnimateOnScroll>

    </div>
  );
};

export default AboutTeamPage;